<template>
  <article class="about_Container">
    <h3 class="wow fadeInUp">{{ title }}</h3>
    <section class="content">
      <section class="program_spacification">
        <p class="wow fadeInUp" v-for="(spec, index) in data" :key="index">
          <i class="far fa-check-circle"></i>
          {{ spec }}
        </p>
      </section>
      <section class="program_img_container wow bounceIn">
        <img :src="getImgUrl(img)" loading="lazy" draggable="false" />
      </section>
    </section>
  </article>
</template>

<script>
import { getImgUrl } from "@/util/methods";
export default {
  name: "ProjectPageAbout",
  props: ["title", "data", "img"],
  methods: {
    getImgUrl,
  },
};
</script>

<style></style>
